import React, { useState } from 'react'
import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { OwnSummaryHeaderColumn, excelHeaderSummary } from '../constant'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { focusElemnt, navigation3 } from '../../../../common/helper'
const DeliveryReportSummary = (props) => {
  const {loginCountryId, loginData, toDate, fromDate, tableData, sourceCity, sourceBranch, sourceBranchUser, paymentMode, paymentType, selReportView } = props
  const [state, setState] = useState({
    filter: false,
    generatePDF: false,
    load: false,
    buttonsShow: false,
  })
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const { filter, generatePDF, load, buttonsShow } = { ...state }
  const [isPdfLoading, setIsPdfLoading] = useState(true)
  // const [tableData, setTableData] = useState([{ isSubHeading: true, SN: 'Payment Mode: Cash', delchrge: 'Branch: Maven Ops Ahmedabad' },{ SN: '1', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '2', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '3', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '4', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '5', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '6', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '7', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { SN: '8', payType: 'Paid', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }, { isTotal: true, SN: 'Total Cash, Maven Ops Ahmedabad', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265'}, { isTotal: true, SN: 'Total All, Maven Ops Ahmedabad', Unit: '10', frtCharge: '100', Kmfright: '110', BkgOthChrge: '10', delchrge: '100', delHam: '110', extraHam: '10', demChrge: '100', delGST: '110', delDiscount: '100',netAmt: '265' }])
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        <TableRow>
          {
            item.isSubHeading ?
              <>
                <TableCell
                  className="reportTD"
                  colSpan={loginCountryId===2?6:7}
                  style={{ background: '#f1f9ff', fontSize: fontVal, fontWeight: '500', height: '36px', textAlign: 'left' }}
                >
                  {item.SN}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={6}
                  style={{ background: '#f1f9ff', fontSize: fontVal, fontWeight: '500', height: '36px', textAlign: 'right' }}
                >
                  {item.DeliveryHamali}
                </TableCell>
              </> : item.isTotal ?
                <>
                  <TableCell
                    className="reportTD"
                    colSpan={2}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'left', }}
                  >
                    {item.SN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.Items}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.Freight?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.KMFreight?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.BkgOtherCharges?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.DeliveryCartage?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.DeliveryHamali?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.ExtraHamali?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.DemurrageChg?.toFixed(2)}
                  </TableCell>
                  {loginCountryId!==2&&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.DeliveryGST?.toFixed(2)}
                  </TableCell>
                  }
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#444", height: '36px', textAlign: 'right' }}
                  >
                    {item.DeliveryDisc?.toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: '#EEEEEE', fontSize: fontVal, fontWeight: 'bold', color: "#0086ff", textAlign: 'right', height: '36px' }}
                  >
                    {item.NetAmount?.toFixed(2)}
                  </TableCell>
                </> : <>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.SN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.PaymentType}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.Items}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.Freight}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.KMFreight}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.BkgOtherCharges}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryCartage}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryHamali}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.ExtraHamali}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DemurrageChg}
                  </TableCell>
                  {loginCountryId!==2&&
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryGST}
                  </TableCell>
                  }
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.DeliveryDisc}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right', color: "#0086ff" }}
                  >
                    {item.NetAmount}
                  </TableCell>
                </>
          }
        </TableRow>
      </>
    )
  }
  const printClick = (isSave) => {
    setIsPdfLoading(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);

    const HeaderColumns = excelHeaderSummary.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = OwnSummaryHeaderColumn?.filter(col => loginCountryId !== 2 || col.field !== 'DeliveryGST')?.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const HeaderData = [
      {
        City: sourceCity?.SourceCityName,
        Branch: sourceBranch?.SourceBranchName,
        User: sourceBranchUser?.UserName,
        PayMode: paymentMode?.Name,
        PayType: paymentType?.Name,
        ReportView: selReportView?.ReportView
      },
    ]
    const doc = new jsPDF({ orientation: 'p', format: [1239, 1754], unit: 'px', compress: true })

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }

    let drawCell = function (data) {
      var rows = data.table.body
      rows.map((val) => {
        if (val.raw.isSubHeading) {
          val.cells[0].colSpan = 6
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.fillColor = [241, 249, 255]
          val.cells[6].colSpan = loginCountryId===2?6:7
          val.cells[6].styles.font = 'Roboto'
          val.cells[6].styles.fontStyle = 'normal'
          val.cells[6].styles.fontSize = '16'
          val.cells[6].styles.textColor = [0, 0, 0]
          val.cells[6].styles.halign = 'right'
          val.cells[6].styles.fillColor = [241, 249, 255]
        }
        if (val.raw.isTotal) {
          val.cells[0].colSpan = 2
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = "left"
          val.cells[0].styles.fillColor = [238, 238, 238]
          if (loginCountryId===2) {
            for (let i = 2; i <= 11; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'normal'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.halign = i == 0 ? "left" : 'right'
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }else{
            for (let i = 2; i <= 12; i++) {
              val.cells[i].colSpan = 1
              val.cells[i].styles.font = 'Roboto'
              val.cells[i].styles.fontStyle = 'normal'
              val.cells[i].styles.fontSize = '16'
              val.cells[i].styles.textColor = [0, 0, 0]
              val.cells[i].styles.halign = i == 0 ? "left" : 'right'
              val.cells[i].styles.fillColor = [238, 238, 238]
            }
          }
          
        }
      })
    }

    doc.setProperties({
      title: `Delivery Report.pdf`,
      subject: 'Delivery Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Collection Date: ${moment(fromDate).format("DD-MMM-YYYY")} To ${moment(toDate).format("DD-MMM-YYYY")} `, data.settings.margin.left, 150)
        doc.text(`Report: Own Deliveries`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      columnStyles: {
        0: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        2: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        3: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        4: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        5: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        6: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        7: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        8: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        9: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        10: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        11: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
        12: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      // showHead: "never",
      didParseCell: (data) => {
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        drawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Delivery Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Delivery Summary Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('deliverySummaryReportoutput').data = pdfUrl
        // document.getElementById('deliverySummaryReportoutput').data = doc.output('datauristring', 'DeliverySummaryReport..pdf')
        focusElemnt('deliveryBackBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('deliverySummaryReportoutput').data = pdfUrl
        // document.getElementById('deliverySummaryReportoutput').data = doc.output('datauristring', 'DeliverySummaryReport..pdf')
        focusElemnt('deliveryBackBtn')
      }, 2000)
    }

  }
  return (
    <>
      <Box sx={{ ...sx.reportFlex, paddingRight: '17px', paddingTop: "0px", justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
          Report For: Delivery Report
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'end', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="itemButtons">
          {isPdfLoading ? (
            <>
              <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, 'exportAsPdfBtn', 'DeliverySplitBtn', () => { })}>
                <ReactHtmlTableToExcel
                  id="ExpToExlbtn"
                  className="receiveitemExcelBtn"
                  table="delTable"
                  filename={`Delivery Summary Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id="exportAsPdfBtn"
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                  onClick={() => { setIsPdfLoading(false); printClick(true) }}
                >
                  Export As PDF
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  id="PrintBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'exportAsPdfBtn', () => { })}
                  onClick={() => { setIsPdfLoading(false); printClick(false) }}
                >
                  Print
                </Button>
              </Item>
            </>
          ) : (
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button id='deliveryBackBtn' variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                onClick={() => setIsPdfLoading(true)}
                onKeyDown={(e) => navigation3(e, 'deliveryBackBtn', 'deliveryBackBtn', () => { setIsPdfLoading(true); focusElemnt('DeliverySplitBtn') })}
              >
                Back
              </Button>
            </Item>
          )}
        </Box>
      </Box>
      {isPdfLoading ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 395, marginTop: "16px" }} >
            <TableContainer className="lr-popup-table lrModel scrollBlue" component={Paper} style={{ borderRadius: "6px" }}>
              <Table size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0', width: '100%' }}>
                  <TableRow style={{ color: 'white' }}>
                    {OwnSummaryHeaderColumn?.filter(col => loginCountryId !== 2 || col.field !== 'DeliveryGST')?.map((item, i) => (
                      <TableCell className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '12px', fontWeight: 'bold', textAlign: item.align, height: '36px', }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={24}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData.length > 1 ? (
                  <TableBody className="filter-data-row" style={{ border: "none" }}>
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table id="delTable" style={{ display: 'none' }} size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0', width: '100%' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Delivery Report -</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'right' }} colSpan={6}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={13}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderSummary?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '20px', fontWeight: 'bold', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {sourceCity?.SourceCityName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={3}
                    >
                      {sourceBranch?.SourceBranchName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {sourceBranchUser?.UserName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {paymentMode?.Name}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {paymentType?.Name}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {selReportView?.ReportView}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={13}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {OwnSummaryHeaderColumn?.filter(col => loginCountryId !== 2 || col.field !== 'DeliveryGST')?.map((item, i) => (
                      <TableCell className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: 'bold', textAlign: item.align, height: '36px', }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={24}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData.length > 1 ? (
                  <TableBody className="filter-data-row" style={{ border: "none" }}>
                    {tableData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>

        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="deliverySummaryReportoutput"
              type="application/pdf"
              width="100%"
              height="440"
              title="MTLPL -Cargo System - DeliveryReport Summary Report "
              aria-label="MTLPL -Cargo System - DeliveryReport Summary  Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default DeliveryReportSummary